export default {
    'chat.title': 'Messages',
    'chat.type.influencers': 'Influencers',
    'chat.type.p2p': 'Post2Post'
};